
import { updateGtagTitle } from '@/lib/utils';
import React, { useEffect } from 'react';

let currentUrl = window.location.href;

export function updateMatomo(){
  //@ts-ignore
  const _paq = window._paq = window._paq || [];
  _paq.push(['setCustomUrl', window.location.pathname]);
  _paq.push(['setDocumentTitle', document.title]);
  _paq.push(['setReferrerUrl', currentUrl]);
  currentUrl = location.href;

  // remove all previously assigned custom variables, requires Matomo (formerly Piwik) 3.0.2
  _paq.push(['deleteCustomVariables', 'page']);
  _paq.push(['trackPageView']);

  // make Matomo aware of newly added content
  const content = document.getElementById('content');
  _paq.push(['MediaAnalytics::scanForMedia', content]);
  _paq.push(['FormAnalytics::scanForForms', content]);
  _paq.push(['trackContentImpressionsWithinNode', content]);
  _paq.push(['enableLinkTracking']);
}

export const usePageTitleTracking = () => {
  const title = React.useRef(document.title);
  
  useEffect(()=>{
    const titleObserver = new MutationObserver(() => {
      // console.log('Page title changed!', document.title);
      if(document.title=='Online billboard booking'){
        // console.log('Page title is default, skipping update');
        return;
      }
      if(document.title === title.current) return;
      console.log('Page title changed to:', document.title);
      updateMatomo();
      updateGtagTitle()
      title.current = document.title;
      // You can fire your analytics here
      // e.g., _paq.push(['setDocumentTitle', document.title]);
    });
    
    const titleEl = document.querySelector('title');
    
    if (titleEl) {
      titleObserver.observe(titleEl, { childList: true });
    }
    
    // updateMatomo();
  },[])
};